import { ONE_YEAR_IN_SECONDS } from './constants'

export const COOKIE_CHANGE_EVENT = 'skop:cookie-change'
export const COOKIE_STORAGE_KEY = 'skop:cookie-update'

export function emitCookieChange(name: string): void {
  if (typeof window === 'undefined') return

  // Dispatch event for current tab
  window.dispatchEvent(
    new CustomEvent(COOKIE_CHANGE_EVENT, { detail: { name } }),
  )

  // Update localStorage to trigger 'storage' event in other tabs
  try {
    localStorage.setItem(
      COOKIE_STORAGE_KEY,
      JSON.stringify({ name, timestamp: Date.now() }),
    )
  } catch {
    // ignore
  }
}

export function getNavbarCollapsedFromCookieClient(): boolean {
  if (typeof document === 'undefined') return false
  const cookie = document.cookie
    .split('; ')
    .find((c) => c.startsWith('navbar_collapsed='))
  return cookie?.split('=')[1] === '1'
}

export type ClientCookieOptions = {
  readonly path?: string
  readonly domain?: string
  readonly maxAge?: number
  readonly sameSite?: 'lax' | 'strict' | 'none'
  readonly secure?: boolean
}

export function setClientCookie(
  name: string,
  value: string,
  options?: ClientCookieOptions,
): void {
  if (typeof document === 'undefined') return

  const path = options?.path ?? '/'
  const domain = options?.domain
  const sameSite = options?.sameSite ?? 'lax'
  const secure = options?.secure ?? process.env.NODE_ENV === 'production'
  const maxAge = options?.maxAge ?? ONE_YEAR_IN_SECONDS

  const parts: string[] = []
  parts.push(`${name}=${value}`)
  parts.push(`Path=${path}`)
  parts.push(`SameSite=${sameSite.charAt(0).toUpperCase()}${sameSite.slice(1)}`)
  if (typeof maxAge === 'number') parts.push(`Max-Age=${maxAge}`)
  if (domain) parts.push(`Domain=${domain}`)
  if (secure) parts.push('Secure')

  document.cookie = parts.join('; ')
  emitCookieChange(name)
}

export const readClientCookie = (name: string): string | undefined => {
  if (typeof document === 'undefined') return undefined
  const pref = `${name}=`
  const parts = document.cookie.split(';')
  for (let i = 0; i < parts.length; i++) {
    const c = parts[i].trim()
    if (c.startsWith(pref)) return c.substring(pref.length)
  }
  return undefined
}
